import { useRef, useState } from 'react';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { RouteName, TextKey } from '@mews-commander/enums';
import { TooltippedSpan } from '@mews-commander/ui';
import { LocalizedProperty, lt } from '@mews/framework';
import { useResolveRoute } from '@mews/routing';
import { Container, DropDownButton, DropdownItem, Link } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { PolymorphicProductDialog } from '../../../../../modules/productServiceOrder/components/ProductServiceOrderDialog/AddProduct/PolymorphicProductDialog';
import { AddProductsAction as AddProductsActionType } from './types';

interface Props {
    action: AddProductsActionType;
}

export const AddProductsAction = ({ action: { accountId } }: Props) => {
    const [activeServiceId, setActiveServiceId] = useState<string | null>(null);
    const currentEnterpriseId = useCurrentEnterpriseId();
    const linkRef = useRef<HTMLAnchorElement>(null);
    const { data } = useRepositoryQuery('services', 'getAll', {
        enterpriseIds: [currentEnterpriseId],
    });
    const resolveUrl = useResolveRoute();

    const options = data?.services;

    const createServiceOrderInDialog = (serviceId: string | null) => {
        setActiveServiceId(serviceId);
    };

    return (
        <>
            <Container padding={['0', '100', '0', '0']}>
                <TooltippedSpan tooltip={lt(TextKey.Create)}>
                    <DropDownButton icon={IconName.PlusSimple} size="medium">
                        <DropdownItem
                            label={
                                <Link
                                    variant="basic"
                                    underline={false}
                                    ref={linkRef}
                                    onClick={(e) => e.stopPropagation()}
                                    href={resolveUrl(RouteName.ReservationCreate, {
                                        query: {
                                            HotelId: currentEnterpriseId,
                                            CustomerId: accountId,
                                        },
                                    })}
                                >
                                    {lt(TextKey.Reservation)}
                                </Link>
                            }
                            onClick={() => linkRef.current?.click()}
                        />
                        {options?.map(({ id, names }) => (
                            <DropdownItem
                                label={<LocalizedProperty property={names} />}
                                value={String(id)}
                                onClick={() => createServiceOrderInDialog(id)}
                                key={id}
                            />
                        )) || null}
                    </DropDownButton>
                </TooltippedSpan>
            </Container>

            {activeServiceId && (
                <PolymorphicProductDialog
                    onClose={() => setActiveServiceId(null)}
                    serviceId={activeServiceId}
                    accountId={accountId}
                    active
                />
            )}
        </>
    );
};
